jQuery(document).ready(function () {

	/**
	 * weekly question
	 */

	jQuery('.js-weekly-question').on('click', function (e) {
		e.preventDefault();
		jQuery('.js-sticky-button').find('.jam').addClass('jam-message-writing');
		jQuery('.js-sticky-menu').removeClass('js-sticky-menu-active');
		jQuery('.js-overlay-weekly-question').toggleClass('js-overlay-active');
	});

	//trigger pop up for weekly questions and newsletter
	if (window.location.href.indexOf('#veckansfraga') > 0) {
		jQuery('.js-sticky-button').find('.jam').addClass('jam-message-writing');
		jQuery('.js-sticky-menu').removeClass('js-sticky-menu-active');
		jQuery('.js-overlay-weekly-question').toggleClass('js-overlay-active');
	}

	var radioBoxes = jQuery('.js-weekly-question-radio-input');
	radioBoxes.change(function () {
		jQuery('.js-weekly-question-submit').prop('disabled', radioBoxes.filter(':checked').length < 1);
	});
	radioBoxes.change();

	jQuery('.js-weekly-question-submit').on('click', function (e) {
		e.preventDefault();
		record_poll_vote(jQuery('.js-weekly-question-radio-input').filter(':checked').val(), jQuery(this).attr('id'));

	});

	function record_poll_vote(selectedVote,id) {
		jQuery.ajax({
			url: ajax.ajaxurl,
			dataType: 'html',
			type: 'POST',
			data: {
				'selectedVote': selectedVote,
				'questionID' : id,
				'action': 'record_poll_vote'
			},
			success: function (data) {
				jQuery('#vote-section').empty();
				jQuery('#vote-section').append(data);
				jQuery('#'+id).remove(); //remove vote button
				jQuery('#wq-response').text('Din röst har registrerats');
				setTimeout(function(){ jQuery('#wq-response').empty() }, 3000);
			}
		});
	}

});

